import React, { Component } from 'react';
import { array, bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import moment from 'moment';
import { Form as FinalForm, Field } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import {
  AddImages,
  Button,
  EditListingWizardButtons,
  FieldCheckboxGroup,
  FieldTextInput,
  Form,
  IconArrowHead,
  IconDelete,
  InfoTipForFields,
  FieldDateInput
} from '../../components';
import arrayMutators from 'final-form-arrays';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { FieldArray } from 'react-final-form-arrays';
import { findOptionsForSelectFilter } from '../../util/search';
import config from '../../config';

import css from './EditListingPostsForm.module.css';

export class EditListingPostsFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeNewsIndex: 0,
      activeContentIndex: 0,
      activeEventsIndex: 0,
      showNewsForm: false,
      showContentForm: false,
      showEventsForm: false,
      focusInputDate: ''
    };
  }

  render() {
    return (
      <FinalForm
        {...this.props}
        mutators={{ ...arrayMutators }}
        initialValues={{
          ...this.props.initialValues,
        }}
        render={formRenderProps => {
          const {
            className,
            fetchErrors,
            handleSubmit,
            images,
            imageUploadRequested,
            intl,
            invalid,
            disabled,
            ready,
            saveActionMsg,
            updated,
            updateInProgress,
            isClient,
            form,
            form: {
              mutators: { push },
            },
            values,
            listing,
            onSetNews,
            onSetContent,
            onSetEvents,
            setLatesNewsAddedDate,
            isDraftListing,
            onHandlePreviewPopup
          } = formRenderProps;

          const { publishListingError, showListingsError, updateListingError } = fetchErrors || {};

          // NOTE: These error messages are here since Photos panel is the last visible panel
          // before creating a new listing. If that order is changed, these should be changed too.
          // Create and show listing errors are shown above submit button
          const publishListingFailed = publishListingError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingPostsForm.publishListingFailed" />
            </p>
          ) : null;
          const showListingFailed = showListingsError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingPostsForm.showListingFailed" />
            </p>
          ) : null;


          const submitReady = (updated) || ready;
          const submitInProgress = updateInProgress;
          const submitDisabled = 
          disabled || 
          submitInProgress || 
          imageUploadRequested || 
          ready || 
          values?.images?.length <= 1;
          const categoryOptions = findOptionsForSelectFilter('category', config.custom.filters);

          const classes = classNames(css.root, className);
          const publicData = listing?.attributes?.publicData;

          const setAciveItem = (index, postType) => {
            if (postType === "news") {
              this.setState({ activeNewsIndex: index })
            }
            else if (postType === "content") {
              this.setState({ activeContentIndex: index })
            }
            else {
              this.setState({ activeEventsIndex: index })
            }
          }

          const onHandleAddNews = () => {
            push(`news`, { id: Date.now() }),
              setLatesNewsAddedDate(),
              setAciveItem(values?.news?.length, "news"),
              this.setState({ showNewsForm: true })
          }

          const onHandleAddContent = () => {
            push(`content`, { id: Date.now() }),
              setLatesNewsAddedDate(),
              setAciveItem(values?.content?.length, "content")
            this.setState({ showContentForm: true })
          }

          const onHandleAddEvents = () => {
            
            push(`events`, { id: Date.now() }),
              // setLatesNewsAddedDate(),
              setAciveItem(values?.events?.length, "events")
            this.setState({ showEventsForm: true })
          }

          const currentNews = values?.news;
          const currentContent = values?.content;
          const currentEvents = values?.events;

          const {
            activeNewsIndex,
            activeContentIndex,
            activeEventsIndex,
            showNewsForm,
            showContentForm,
            showEventsForm,
          } = this.state;

          return (
            <Form
              className={classes}
              onSubmit={e => {
                handleSubmit(e);
                setTimeout(() => {
                  this.setState({ showNewsForm: false })
                  this.setState({ showContentForm: false })
                  this.setState({ showEventsForm: false })
                }, 500)
              }}
            >
              {updateListingError ? (
                <p className={css.error}>
                  <FormattedMessage id="EditListingPostsForm.updateFailed" />
                </p>
              ) : null}


              <div className={css.questionsSection}>
                <h2 className={css.dynamicItemTitle}>
                  <span>
                    <FormattedMessage id="EditListingPostsForm.newsTitle" />
                    <InfoTipForFields tipId="EditListingPostsForm.newsTip" />
                  </span>
                  <AddIcon className={css.addButton} onClick={() => onHandleAddNews()} />
                </h2>
                <FieldArray name={`news`}>
                  {({ fields }) => {
                    return fields.map((name, index) => {
                      const isSelected = activeNewsIndex === index;
                      return <>
                        {showNewsForm && (
                          <div key={`${name}-${index}`}>
                            <h3
                              className={classNames(css.accordionTitle, { [css.accordionTitleSelected]: isSelected })}
                              onClick={() => setAciveItem(index, "news")}
                            >
                              {currentNews?.[index]?.title || `News-${index + 1}`}
                              <IconArrowHead size="small" direction={isSelected ? "up" : "down"} />
                            </h3>

                            <div className={classNames(css.dynamicFieldWrapper, { [css.dynamicFieldWrapperActive]: isSelected })}>
                              <div className={css.closeIconWrapper} onClick={() => { fields.remove(index) }}>
                                <IconDelete />
                              </div>

                              <label className={css.dynamicItemLabel}>
                                <FormattedMessage id="EditListingPostsForm.titleLabel" />
                              </label>
                              <Field
                                name={`${name}.title`}
                                className={css.dynamicField}
                                component="input"
                                placeholder={'Title'}
                              />

                              <label className={css.dynamicItemLabel}>
                                <FormattedMessage id="EditListingPostsForm.descriptionLabel" />
                              </label>
                              <Field
                                name={`${name}.description`}
                                className={css.dynamicField}
                                component="textarea"
                                placeholder={'Description'}
                              />

                              <label className={css.dynamicItemLabel}>
                                <FormattedMessage id="EditListingPostsForm.linkLabel" />
                              </label>
                              <Field
                                name={`${name}.link`}
                                className={css.dynamicField}
                                component="input"
                                placeholder={'www.example.com'}
                              />

                              <FieldCheckboxGroup
                                label={intl.formatMessage({
                                  id: 'EditListingPostsForm.catetgoryLabel',
                                })}
                                className={css.checkboxesField2}
                                id={`${name}.category`}
                                name={`${name}.category`}
                                options={categoryOptions}
                                twoColumns={true}
                                radio={false}
                              />
                            </div>
                          </div>
                        )}
                      </>
                    });
                  }}
                </FieldArray>
                <OnChange name='news'>
                  {(curr, prev) => {
                    onSetNews(curr);
                  }}
                </OnChange>
              </div>


              <div className={css.questionsSection}>
                <h2 className={css.dynamicItemTitle}>
                  <span>
                    <FormattedMessage id="EditListingPostsForm.contentTitle" />
                    <InfoTipForFields tipId="EditListingPostsForm.contentTip" />
                  </span>
                  <AddIcon className={css.addButton} onClick={() => onHandleAddContent()} />
                </h2>
                <FieldArray name={`content`}>
                  {({ fields }) => {
                    return fields.map((name, index) => {
                      const isSelected = activeContentIndex === index;
                      return <>
                        {showContentForm && (
                          <div key={`${name}-${index}`}>
                            <h3
                              className={classNames(css.accordionTitle, { [css.accordionTitleSelected]: isSelected })}
                              onClick={() => setAciveItem(index, "content")}
                            >
                              {currentContent?.[index]?.title || `Content-${index + 1}`}
                              <IconArrowHead size="small" direction={isSelected ? "up" : "down"} />
                            </h3>

                            <div className={classNames(css.dynamicFieldWrapper, { [css.dynamicFieldWrapperActive]: isSelected })}>
                              <div className={css.closeIconWrapper} onClick={() => { fields.remove(index) }}>
                                <IconDelete />
                              </div>

                              <label className={css.dynamicItemLabel}>
                                <FormattedMessage id="EditListingPostsForm.titleLabel" />
                              </label>
                              <Field
                                name={`${name}.title`}
                                className={css.dynamicField}
                                component="input"
                                placeholder={'Title'}
                              />

                              <label className={css.dynamicItemLabel}>
                                <FormattedMessage id="EditListingPostsForm.descriptionLabel" />
                              </label>
                              <Field
                                name={`${name}.description`}
                                className={css.dynamicField}
                                component="textarea"
                                placeholder={'Description'}
                              />

                              <label className={css.dynamicItemLabel}>
                                <FormattedMessage id="EditListingPostsForm.linkLabel" />
                              </label>
                              <Field
                                name={`${name}.link`}
                                className={css.dynamicField}
                                component="input"
                                placeholder={'www.example.com'}
                              />
                              <FieldCheckboxGroup
                                label={intl.formatMessage({
                                  id: 'EditListingPostsForm.catetgoryLabel',
                                })}
                                className={css.checkboxesField2}
                                id={`${name}.category`}
                                name={`${name}.category`}
                                options={categoryOptions}
                                twoColumns={true}
                                radio={false}
                              />
                            </div>

                          </div>
                        )}
                      </>
                    });
                  }}
                </FieldArray>
                <OnChange name='content'>
                  {(curr, prev) => {
                    onSetContent(curr);
                  }}
                </OnChange>
              </div>




              <div className={css.questionsSection}>
                <h2 className={css.dynamicItemTitle}>
                  <span>
                    <FormattedMessage id="EditListingPostsForm.eventsTitle" />
                    <InfoTipForFields tipId="EditListingPostsForm.eventTip" />
                  </span>
                  <AddIcon className={css.addButton} onClick={() => onHandleAddEvents()} />
                </h2>
                <FieldArray name={`events`}>
                  {({ fields }) => {
                    return fields.map((name, index) => {
                      const isSelected = activeEventsIndex === index;
                      return <>
                        {showEventsForm && (
                          <div key={`${name}-${index}`}>
                            <h3
                              className={classNames(css.accordionTitle, { [css.accordionTitleSelected]: isSelected })}

                              onClick={() => setAciveItem(index, "events")}
                            >
                              {currentEvents?.[index]?.title || `Event-${index + 1}`}
                              <IconArrowHead size="small" direction={isSelected ? "up" : "down"} />
                            </h3>

                            <div className={classNames(css.dynamicFieldWrapper, { [css.dynamicFieldWrapperActive]: isSelected })}>

                              <div className={css.closeIconWrapper} onClick={() => { fields.remove(index) }}>
                                <IconDelete />
                              </div>

                              <label className={css.dynamicItemLabel}>
                                <FormattedMessage id="EditListingPostsForm.titleLabel" />
                              </label>
                              <Field
                                name={`${name}.title`}
                                className={css.dynamicField}
                                component="input"
                                placeholder={'Title'}
                              />

                              <label className={css.dynamicItemLabel}>
                                <FormattedMessage id="EditListingPostsForm.linkLabel" />
                              </label>
                              <Field
                                name={`${name}.link`}
                                className={css.dynamicField}
                                component="input"
                                placeholder={'www.example.com'}
                              />

                              <label className={css.dynamicItemLabel}>
                                <FormattedMessage id="EditListingPostsForm.dateLabel" />
                              </label>
                              <FieldDateInput
                                className={classNames(css.dynamicField, css.dynamicFieldDate, css[this.state.focusInputDate])}
                                name={`${name}.eventDate`}
                                useMobileMargins={false}
                                onFocus={() => {this.setState({focusInputDate: 'dynamicFieldDateMargin'})}}
                                onBlur={() => {this.setState({focusInputDate: ''})}}
                                id={`${name}.eventDate`}
                                placeholderText={moment().format('ddd, MMM D')}
                                format={v =>
                                  v && v.date ? {date: moment.tz(moment(v.date).format('YYYY-MM-DD HH:mm:ss'), "Etc/UTC").toDate()} : v
                                }
                                parse={v =>
                                  v && v.date ? {date: v.date.toString()} : v
                                }
                              />

                              <label className={css.dynamicItemLabel}>
                                <FormattedMessage id="EditListingPostsForm.discountCodeLabel" />
                              </label>
                              <Field
                                name={`${name}.discountCode`}
                                className={css.dynamicField}
                                component="input"
                                placeholder={'Enter code'}
                                maxlength="16"
                              />

                            </div>
                          </div>
                        )}
                      </>
                    });
                  }}
                </FieldArray>
                <OnChange name='events'>
                  {(curr, prev) => {
                    onSetEvents(curr);
                  }}
                </OnChange>
              </div>

              {publishListingFailed}
              {showListingFailed}

              <EditListingWizardButtons
                inProgress={submitInProgress}
                disabled={!isClient && submitDisabled}
                ready={submitReady}
                saveActionMsg={saveActionMsg}
                isDraftListing={isDraftListing}
                isClient={isClient}
                isPostsTab
                onHandlePreviewPopup={onHandlePreviewPopup}
                listingData={{ values }}
              />
            </Form>
          );
        }}
      />
    );
  }
}

EditListingPostsFormComponent.defaultProps = { fetchErrors: null, images: [] };

EditListingPostsFormComponent.propTypes = {
  fetchErrors: shape({
    publishListingError: propTypes.error,
    showListingsError: propTypes.error,
    uploadImageError: propTypes.error,
    updateListingError: propTypes.error,
  }),
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
};

export default compose(injectIntl)(EditListingPostsFormComponent);
